import { datadogLogs } from '@datadog/browser-logs'

class WidgetStorage {
  constructor() {
    this.storageProvider = {
      setItem: new Function(),
      getItem: new Function(),
      removeItem: new Function(),
    }
  }

  configureBotId = botId => {
    this.botId = botId
    this.keys = {
      chatId: `widget-${botId}-chatId`,
      isOpen: `widget-${botId}-isOpen`,
      isConversationInitialized: `widget-${botId}-isConversationInitialized`,
      ref: `widget-${botId}-ref`,
    }
  }

  configure = (storageType, botId) => {
    this.storageType = storageType
    this.botId = botId
    this.keys = {
      chatId: `widget-${botId}-chatId`,
      isOpen: `widget-${botId}-isOpen`,
      isConversationInitialized: `widget-${botId}-isConversationInitialized`,
      ref: `widget-${botId}-ref`,
    }

    try {
      if (storageType === 'LOCAL_STORAGE') {
        this.storageProvider = localStorage
        sessionStorage.removeItem(this.keys.chatId)
      } else if (storageType === 'SESSION_STORAGE') {
        this.storageProvider = sessionStorage
        localStorage.removeItem(this.keys.chatId)
      } else if (storageType === 'NONE') {
        sessionStorage.removeItem(this.keys.chatId)
        localStorage.removeItem(this.keys.chatId)
      }
    } catch (error) {
      datadogLogs.logger.error(error)
    }
  }

  isEnabled = () => {
    return this.storageType !== 'NONE'
  }

  isWidgetOpened = () => {
    try {
      return sessionStorage.getItem(this.keys.isOpen) === 'true'
    } catch (error) {
      return this.storageProvider.getItem(this.keys?.isOpen)
    }
  }

  getRef = () => {
    try {
      return localStorage.getItem(this.keys.ref)
    } catch (error) {
      return this.storageProvider.getItem(this.keys.ref)
    }
  }

  isConversationInitialized = () => {
    try {
      return localStorage.getItem(this.keys.isConversationInitialized) === 'true'
    } catch (error) {
      return this.storageProvider.getItem(this.keys.isConversationInitialized)
    }
  }

  setRef = ref => {
    try {
      localStorage.setItem(this.keys.ref, ref)
    } catch (error) {
      this.storageProvider.setItem(this.keys.ref, ref)
    }
  }

  setChatId = chatId => {
    try {
      if (!chatId && this.storageType === 'NONE') {
        sessionStorage.removeItem(this.keys.chatId)
        localStorage.removeItem(this.keys.chatId)
      } else if (chatId) {
        this.storageProvider.setItem(this.keys.chatId, String(chatId))
      }
    } catch (error) {
      this.storageProvider.setItem(this.keys.chatId, String(chatId))
    }
  }

  setIsWidgetOpened = isOpened => {
    try {
      sessionStorage.setItem(this.keys.isOpen, isOpened)
    } catch (error) {
      this.storageProvider.setItem(this.keys.isOpen, isOpened)
    }
  }

  setIsConversationInitialized = isConversationInitialized => {
    try {
      localStorage.setItem(this.keys.isConversationInitialized, isConversationInitialized)
    } catch (error) {
      this.storageProvider.setItem(this.keys.isConversationInitialized, isConversationInitialized)
    }
  }

  setIsWidgetOpenedIfNull = isOpened => {
    try {
      if (sessionStorage.getItem(this.keys.isOpen) === null) {
        sessionStorage.setItem(this.keys.isOpen, isOpened)
      }
    } catch (error) {
      if (this.storageProvider.getItem(this.keys.isOpen) === null) {
        this.storageProvider.setItem(this.keys.isOpen, isOpened)
      }
    }
  }

  tryFindChatIdInAnyStorage = () => {
    try {
      return this.keys
        ? localStorage.getItem(this.keys.chatId) ||
            sessionStorage.getItem(this.keys.chatId)
        : null
    } catch (error) {
      return this.keys ? this.storageProvider.getItem(this.keys.chatId) : null
    }
  }

  findChatIdInAnyStorage = botId => {
    return localStorage.getItem(`widget-${botId}-chatId`)
        || sessionStorage.getItem(`widget-${botId}-chatId`)
  }

  clearStorage(botId) {
    try {
      localStorage.removeItem(`widget-${botId}-chatId`)
      sessionStorage.removeItem(`widget-${botId}-chatId`)
      localStorage.removeItem(`widget-${botId}-isOpen`)
      sessionStorage.removeItem(`widget-${botId}-isOpen`)
      localStorage.removeItem(`widget-${botId}-isConversationInitialized`)
      sessionStorage.removeItem(`widget-${botId}-isConversationInitialized`)
      localStorage.removeItem(`widget-${botId}-ref`)
      sessionStorage.removeItem(`widget-${botId}-ref`)
      localStorage.removeItem('passedSelectDatesName')
      sessionStorage.removeItem('passedSelectDatesName')
      localStorage.removeItem('passedQuestionnairesName')
      sessionStorage.removeItem('passedQuestionnairesName')
    } catch (error) {
      const previous = this.storageProvider.getItem(`widget-${botId}-chatId`)

      if (previous) {
        this.storageProvider.removeItem(`widget-${botId}-chatId`)
        this.storageProvider.removeItem(`widget-${botId}-isOpen`)
        this.storageProvider.removeItem(`widget-${botId}-ref`)
      }
    }
  }
}

export default new WidgetStorage()
